import React from "react";

export default function TermsOfService() {
  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        backgroundColor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #e5e5e5",
          padding: "1rem 2rem",
          position: "sticky",
          top: 0,
          zIndex: 1000,
        }}
      >
        <nav
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <a
            href="/"
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              letterSpacing: "-0.5px",
              textDecoration: "none",
            }}
          >
            Collavo
          </a>
          <a
            href="/"
            style={{
              backgroundColor: "transparent",
              color: "#1a1a1a",
              padding: "10px 24px",
              fontSize: "15px",
              fontWeight: "500",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
              display: "inline-block",
            }}
          >
            Back to Home
          </a>
        </nav>
      </header>

      {/* Content */}
      <main
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "4rem 2rem",
        }}
      >
        <h1
          style={{
            fontSize: "48px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "1rem",
            letterSpacing: "-1px",
          }}
        >
          Terms of Service
        </h1>

        <p
          style={{
            fontSize: "15px",
            color: "#737373",
            marginBottom: "3rem",
          }}
        >
          Last updated: February 2026
        </p>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Agreement to Terms
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            By accessing or using Collavo, you agree to be bound by these Terms
            of Service. If you disagree with any part of these terms, you may
            not use our service.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            These terms apply to all users of the platform, including service
            providers and
            churches seeking services.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Description of Service
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Collavo is a platform that connects churches with service providers
           across. We provide:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>Profile creation and management tools for service providers</li>
            <li>Search and discovery features for churches</li>
            <li>Direct communication channels between parties</li>
            <li>Basic account management and dashboard features</li>
          </ul>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            <strong>Important:</strong> Collavo is a connection platform only.
            We do not employ service providers, facilitate payments, or act as a
            booking agent. All arrangements, agreements, and transactions are
            made directly between service providers and churches.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Eligibility
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You must be at least 18 years old to use Collavo. By using this
            service, you represent and warrant that you meet this age
            requirement and have the legal capacity to enter into these terms.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Account Registration and Security
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            When you create an account, you agree to:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain and update your information to keep it accurate</li>
            <li>Maintain the security of your account credentials</li>
            <li>
              Notify us immediately of any unauthorized use of your account
            </li>
            <li>
              Be responsible for all activities that occur under your account
            </li>
          </ul>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You may not share your account with others or create multiple
            accounts for the same individual or organization.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Service Provider Responsibilities
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            If you create a service provider profile, you agree to:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>
              Provide truthful and accurate information about your services
            </li>
            <li>Keep your availability and pricing information up to date</li>
            <li>
              Respond to inquiries from churches in a timely and professional
              manner
            </li>
            <li>Honor commitments you make to churches</li>
            <li>
              Comply with all applicable laws, including tax obligations and
              safeguarding requirements
            </li>
            <li>
              Maintain appropriate insurance and safeguarding clearances where
              required
            </li>
            <li>
              Not misrepresent your qualifications, experience, or affiliations
            </li>
          </ul>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You are solely responsible for determining your pricing, managing
            your schedule, and fulfilling any agreements you make with churches.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Church Responsibilities
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            If you represent a church using Collavo, you agree to:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>Treat service providers with respect and professionalism</li>
            <li>Provide clear information about your event or service needs</li>
            <li>
              Honor any agreements you make regarding dates, times, and
              compensation
            </li>
            <li>
              Conduct appropriate due diligence when engaging service providers
            </li>
            <li>Comply with all applicable safeguarding and employment laws</li>
            <li>
              Not misuse the platform to collect contact information for
              purposes other than legitimate service inquiries
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Prohibited Conduct
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "0.5rem",
            }}
          >
            You agree not to:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
            }}
          >
            <li>Violate any applicable laws or regulations</li>
            <li>Post false, inaccurate, misleading, or defamatory content</li>
            <li>Impersonate any person or organization</li>
            <li>Harass, abuse, threaten, or harm another user</li>
            <li>
              Spam, solicit, or advertise products or services unrelated to
              legitimate ministry connections
            </li>
            <li>
              Attempt to gain unauthorized access to the platform or other
              users' accounts
            </li>
            <li>
              Use automated tools to scrape or collect data from the platform
            </li>
            <li>Interfere with the proper functioning of the platform</li>
            <li>Use the platform for any unlawful or fraudulent purpose</li>
          </ul>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Safeguarding and Child Protection
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Both service providers and churches are responsible for implementing
            appropriate safeguarding measures, especially when services involve
            children or vulnerable adults.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Service providers may be required to provide DBS checks or
            equivalent background checks. Churches are responsible for
            conducting appropriate due diligence before engaging any service
            provider.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            If you become aware of any safeguarding concerns, report them
            immediately to the appropriate authorities.
            {/* and to us at
            safeguarding@collavo.co.uk. */}
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Payment and Fees
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Collavo is currently free to use for service providers. We do not
            process payments or take fees from bookings. All financial
            arrangements are made directly between service providers and
            churches.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We reserve the right to introduce fees for certain features in the
            future. Any such changes will be communicated to users with at least
            30 days' notice.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Intellectual Property
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            The Collavo platform, including its design, features, and content
            (excluding user-generated content), is owned by Collavo and
            protected by copyright and other intellectual property laws.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You retain ownership of any content you post to your profile. By
            posting content, you grant Collavo a non-exclusive, worldwide
            license to use, display, and distribute that content on the
            platform.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Disclaimer of Warranties
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            Collavo is provided "as is" and "as available" without warranties of
            any kind, either express or implied. We do not warrant that:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>The service will be uninterrupted, secure, or error-free</li>
            <li>
              Information on the platform is accurate, complete, or reliable
            </li>
            <li>
              Any particular results will be achieved through use of the service
            </li>
            <li>
              Service providers listed on the platform meet any particular
              standards
            </li>
          </ul>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We do not verify the credentials, background, or qualifications of
            service providers. Users are responsible for conducting their own
            due diligence.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Limitation of Liability
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            To the maximum extent permitted by law, Collavo shall not be liable
            for any indirect, incidental, special, consequential, or punitive
            damages, including loss of profits, data, or goodwill, arising from:
          </p>
          <ul
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginLeft: "1.5rem",
              marginBottom: "1rem",
            }}
          >
            <li>Your use or inability to use the service</li>
            <li>Any conduct or content of service providers or churches</li>
            <li>Unauthorized access to or alteration of your data</li>
            <li>Any other matter relating to the service</li>
          </ul>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We are not responsible for any agreements, disputes, or issues
            between service providers and churches. All arrangements are made at
            your own risk.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Indemnification
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You agree to indemnify and hold harmless Collavo, its officers,
            employees, and agents from any claims, damages, losses, or expenses
            (including legal fees) arising from your use of the service, your
            violation of these terms, or your violation of any rights of another
            party.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Account Termination
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            You may deactivate or delete your account at any time through your
            dashboard settings.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We reserve the right to suspend or terminate your account if you
            violate these terms or engage in conduct that we determine to be
            harmful to other users or the platform. We will provide notice when
            reasonably possible, but we may terminate immediately in cases of
            serious violations.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Dispute Resolution
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            If you have a dispute with another user, you agree to resolve it
            directly with that user. Collavo is not obligated to mediate
            disputes between users.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            Any dispute with Collavo itself shall be governed by the laws of
            England and Wales, and you consent to the exclusive jurisdiction of
            the courts of England and Wales.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Changes to Terms
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            We may update these Terms of Service from time to time. We will
            notify you of any material changes by posting the new terms on this
            page and updating the "Last updated" date. Continued use of the
            service after changes constitutes acceptance of the new terms.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Notifications
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            By creating an account, you agree to receive email notifications
            from Collavo at the email address provided during registration.
            These notifications may include platform news, product updates,
            feature announcements, and other communications related to the
            Collavo service.
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            You may unsubscribe from email notifications at any time by
            updating your notification preferences in your account settings,
            or by contacting Collavo directly. Please note that certain
            service-related communications (such as account security notices)
            may still be sent regardless of your notification preferences.
          </p>
        </section>

        <section style={{ marginBottom: "2.5rem" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Severability
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
            }}
          >
            If any provision of these terms is found to be unenforceable or
            invalid, that provision will be limited or eliminated to the minimum
            extent necessary, and the remaining provisions will remain in full
            force and effect.
          </p>
        </section>
        {/* 
        <section
          style={{
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            border: "1px solid #e5e5e5",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Contact Information
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1rem",
            }}
          >
            If you have questions about these Terms of Service, please contact
            us:
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#1a1a1a",
              fontWeight: "500",
              marginBottom: "0.5rem",
            }}
          >
            Email: legal@collavo.co.uk
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#1a1a1a",
              fontWeight: "500",
            }}
          >
            Safeguarding concerns: safeguarding@collavo.co.uk
          </p>
        </section> */}

        <section
          style={{
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            border: "1px solid #e5e5e5",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            Get In Touch
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#525252",
              lineHeight: "1.7",
              marginBottom: "1.5rem",
            }}
          >
            Have questions, feedback, or just want to say hello?
          </p>
          <a
            href="/contact"
            style={{
              display: "inline-block",
              backgroundColor: "#000",
              color: "#fff",
              padding: "12px 32px",
              fontSize: "15px",
              fontWeight: "500",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textDecoration: "none",
            }}
          >
            Contact Us
          </a>
        </section>
      </main>

      {/* Footer */}
      <footer
        style={{
          borderTop: "1px solid #e5e5e5",
          backgroundColor: "#fff",
          padding: "2rem",
          marginTop: "4rem",
        }}
      >
        <div
          style={{
            maxWidth: "800px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#737373",
              marginBottom: "1rem",
            }}
          >
            <a
              href="/about"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              About
            </a>
            <a
              href="/privacy"
              style={{
                color: "#737373",
                textDecoration: "none",
                marginRight: "1.5rem",
              }}
            >
              Privacy Policy
            </a>
            <a
              href="/contact"
              style={{ color: "#737373", textDecoration: "none" }}
            >
              Contact
            </a>
          </p>
          <p style={{ fontSize: "14px", color: "#737373" }}>
            © 2025 Collavo. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
